/*
 * @Author: your name
 * @Date: 2020-10-13 14:28:22
 * @LastEditTime: 2021-05-06 19:42:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\store\modules\devicelog\devicelog.js
 */
import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            keyword:'',// 
            syscode:'',// 
            appcode:'',
            alerttype:'',// 
            starttime:'',// 
            endtime:'',// 
            serviceurl:'',
            dealstatus:'',
            blockstatus:'',
            extype:'' ,
            dateTypeTitle:'',
            searchTimeRange:'',   
            groupname:''
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {
            shopcode:'',
            devicekeyword:'',
            syscode:'',
        },//
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
        // 告警记录列表
        list(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 告警记录修改
        edit(context, payload) {
            return D.edit({
                ...payload
            })

        },
        //告警记录详情
        details(context, payload) {
            payload.apikey = 'alarmmanager/details'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },

        // 告警人员列表
        userlist(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 告警记录修改
        useredit(context, payload) {
            return D.edit({
                ...payload
            })

        },
        // 告警人员删除
        userdel(context, payload) {
            return D.edit({
                ...payload
            })
        },
        //新增
        useradd(context, payload) {
            return D.add(payload)
        },
        //告警记录详情
        userdetails(context, payload) {
            payload.apikey = 'alarmmanager/userdetails'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },
        // 告警屏蔽服务记录列表
        blocklist(context, payload) {
            return D.select({
                ...payload
            })

        },

        // 按异常码查处饼状图数据
        queryAnalysisByError(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 按超时或失败率   柱状图
        queryFailAndTimeout(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 按异常编码查询 折线图
        queryAnalysisdetailList(context, payload) {
            return D.select({
                ...payload
            })
    
        },
        // 总概览 折线图数据
        queryTotalAnalysisdataList(context, payload) {
            return D.select({
                ...payload
            })

        },

        // 告警 服务详情-折线图
        serviceurldetails(context, payload) {
            return D.select({
                ...payload
            })

        },
        

        // 删除屏蔽服务记录
        deleteblock(context, payload) {
            return D.select({
                ...payload
            })
        
        },

        //查询分组
        searchGroupPage(context, payload) {
            return D.select({
                ...payload
            })
        },

        // 告警分组列表
        grouplist(context, payload) {
            return D.select({
                ...payload
            })

        },
        // 告警分组修改
        groupedit(context, payload) {
            return D.edit({
                ...payload
            })

        },
        // 告警分组删除
        groupdel(context, payload) {
            return D.edit({
                ...payload
            })
        },
        //新增分组
        groupadd(context, payload) {
            return D.add(payload)
        },
        //告警分组详情
        groupdetails(context, payload) {
            payload.apikey = 'alarmmanager/searchGroupPage'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },


        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        keyword:'',// 商户号
                        alerttype:'',// 
                        starttime:'',// 
                        endtime:'',// 
                        serviceurl:'',
                        dealstatus:'',
                        blockstatus:'',
                        syscode:'',
                        appcode:'',
                        dateTypeTitle:'',
                        searchTimeRange:'',
                        groupname:''
                        
                    }
                }
            })
        },
    }
}